import type { SuppliersFilters } from '@app/pages/Warehouses/Suppliers/types';

export const PF = 'suppliers';

export const initialFilters: SuppliersFilters = {
  Page: 1,
  ItemsPerPage: 20,
  SearchTerm: '',
};
